/**
 * Smooth open/close for Disclaimer toggle (<details>).
 */
class DisclaimerToggle extends HTMLElement {
  connectedCallback() {
    if (this.#bound) return;
    this.#bound = true;

    this.details = this.querySelector('details');
    this.panel = this.querySelector('[data-disclaimer-panel]');
    this.summary = this.querySelector('summary');
    if (!this.details || !this.panel || !this.summary) return;

    this.panel.style.overflow = 'hidden';
    this.panel.style.transition =
      'height 0.55s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.45s ease';

    if (this.details.open) {
      this.details.classList.add('is-expanded');
      this.panel.style.height = 'auto';
      this.panel.style.opacity = '1';
    } else {
      this.details.classList.remove('is-expanded');
      this.panel.style.height = '0px';
      this.panel.style.opacity = '0';
    }

    this.summary.addEventListener('click', this.#onSummaryClick);
  }

  disconnectedCallback() {
    this.summary?.removeEventListener('click', this.#onSummaryClick);
  }

  #bound = false;
  #animating = false;

  #onSummaryClick = (event) => {
    event.preventDefault();
    if (this.#animating) return;

    if (this.details.classList.contains('is-expanded')) {
      this.#collapse();
    } else {
      this.#expand();
    }
  };

  #expand() {
    this.#animating = true;
    this.details.open = true;
    this.details.classList.add('is-expanded');
    this.panel.style.opacity = '0';
    this.panel.style.height = '0px';

    void this.panel.offsetHeight;

    const target = this.panel.scrollHeight;
    this.panel.style.height = `${target}px`;
    this.panel.style.opacity = '1';

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      this.panel.style.height = 'auto';
      this.#animating = false;
      this.panel.removeEventListener('transitionend', onEnd);
    };
    this.panel.addEventListener('transitionend', onEnd);
  }

  #collapse() {
    this.#animating = true;
    this.details.classList.remove('is-expanded');

    const current = this.panel.scrollHeight;
    this.panel.style.height = `${current}px`;
    void this.panel.offsetHeight;

    this.panel.style.height = '0px';
    this.panel.style.opacity = '0';

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      this.details.open = false;
      this.#animating = false;
      this.panel.removeEventListener('transitionend', onEnd);
    };
    this.panel.addEventListener('transitionend', onEnd);
  }
}

if (!customElements.get('disclaimer-toggle')) {
  customElements.define('disclaimer-toggle', DisclaimerToggle);
}
